import { jsx } from 'react/jsx-runtime';

function buildVar(name, val) {
    return `--${name}: ${val};`;
}
function Theme({ config = {} }) {
    const vars = Object.entries(config)
        .map(([name, val]) => buildVar(name, val))
        .join('\n');
    return jsx("style", { children: `:root {${vars}}` });
}

export { Theme };
